import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import { Protected } from "../views/Protected";
import { processNativeTabsScreens } from "./nativeTabsOptions";
import { withLayoutContext } from "./withLayoutContext";
var BottomTabNavigator = createBottomTabNavigator().Navigator;
var RNTabs = withLayoutContext(BottomTabNavigator, processNativeTabsScreens);
var Tabs = Object.assign(RNTabs, {
  Protected,
  Screen: RNTabs.Screen
});
var Tabs_default = Tabs;
export {
  Tabs,
  Tabs_default as default
};
//# sourceMappingURL=Tabs.js.map
